app
    .controller('HeaderNotificationCtrl', function ($http, $scope, loginService) {
        this.user = loginService.currentUser;
        $scope.count = 0;
        this.getNotification = () => {
            $http.get(`/notifications/count`)
                .then((response) => {
                    // console.log(response.data);
                    if (response.data.count) {
                        $scope.count = response.data.count;
                    }
                });
        };

        this.$onInit = () => {
            this.getNotification();
        };
    })
    .component('headerNotification', {
        template: `
        <a href="/notifications" ng-if="count" class="red-icon">
            <chat-icon type="notification" width="12" height="15" style="padding: 0 13px"></chat-icon><span class="unreadCount">{{count}}</span>
        </a>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'HeaderNotificationCtrl'
    });
